<template>
    <div class="content">
        <div class="font-flower">拒绝拖延症，快去干</div>
        <van-tabs v-model="activeType" @click="toggleType">
            <van-tab title="进行中"></van-tab>
            <van-tab title="已完成"></van-tab>
            <van-tab title="已删除"></van-tab>
        </van-tabs>
        <div class="balloon-list">
            <div v-for="item in memoRandumList" :key="item.id" :style="{ background: item.backgroundColor }"
                :class="getLengthWidth(item.name.length)" @click="modifyMemorandum(item)">{{ getDisplayName(item.name)
                }}</div>
        </div>
        <button type="button" class="add-fab" aria-label="添加" @click="showModifyMemoRandum = true; clearData()">+</button>
        <van-dialog class="add-menu" v-model="showModifyMemoRandum" :title="id ? '编辑事件' : '添加事件'" showCancelButton
            @confirm="modifyMemorandumConfirm" :beforeClose="beforeClose" @cancel="closeDialog">
            <div v-if="id">
                <span :class="getPosition(index)" v-for="(btn, index) in btnList" :key="btn.id"
                    @click="modifyMemorandumConfirm(btn)">标记{{
                        btn.name }}
                </span>
            </div>
            <van-form label-width="32">
                <van-field label-width="32" v-model="name" label="名字" required />
                <!-- <van-cell label-width="32" title="预计完成日期" :value="finishDate" @click="showCalendar = true" /> -->
                <van-field label-width="32" label="备注" v-model="remark" rows="1" autosize type="textarea" />
                <van-field name="radio" label="提醒">
                    <template #input>
                        <!-- <van-radio-group v-model="remindPeople" direction="horizontal">
                        <van-radio icon-size="12px" name="0">所有人</van-radio>
                        <van-radio icon-size="12px" name="1">爸爸</van-radio>
                        <van-radio icon-size="12px" name="2">妈妈</van-radio>
                        <van-radio icon-size="12px" name="3">奶奶</van-radio>
                    </van-radio-group> -->
                        <van-checkbox-group v-model="remindPeople" direction="horizontal">
                            <van-checkbox icon-size="12px" name="0" shape="square">爸爸</van-checkbox>
                            <van-checkbox icon-size="12px" name="1" shape="square">妈妈</van-checkbox>
                            <van-checkbox icon-size="12px" name="2" shape="square">奶奶</van-checkbox>
                        </van-checkbox-group>
                    </template>
                </van-field>
            </van-form>

        </van-dialog>
        <van-calendar v-model="showCalendar" @confirm="onConfirmDate" />
    </div>
</template>

<script>
import {
    getMemoRandumList,
    updateMemoRandum,
    deleteMemoRandum
} from '../util/api'
import { Dialog } from 'vant';
export default {
    name: 'IndexCom',
    data() {
        return {
            memoRandumList: [],
            activeType: 0,
            showCalendar: false,
            showModifyMemoRandum: false,
            saveSuccessful: false,
            finishDate: '',
            name: null,
            remark: null,
            id: null,
            typeList: [
                {
                    type: 0,
                    name: '进行中'
                },
                {
                    type: 1,
                    name: '已完成'
                },
                {
                    type: 2,
                    name: '已删除'
                }
            ],
            btnList: [{
                type: 1,
                name: '已完成'
            },
            {
                type: 2,
                name: '已删除'
            }],
            remindPeople: [],
            peopleMapping: {
                "0": "爸爸",
                "1": "妈妈",
                "2": "奶奶",
            }
        }
    },
    methods: {
        toggleType(type) {
            this.activeType = type
            this.btnList = this.typeList.filter((item) => item.type !== type)
            this.getList();
        },
        getList: function () {
            getMemoRandumList({ type: this.activeType }).then((res) => {
                this.memoRandumList = res.data.map((item) => {
                    return {
                        ...item,
                        remindPeople: item.remindPeople || "[\"0\",\"1\",\"2\"]",  // 兼容老数据
                        backgroundColor: this.generateRandomBalloon(),
                        diameterClass: this.getLengthWidth(item.name.length)
                    }
                }).filter((item) => {
                    const role = this.$store.state.user?.display_name
                    if (role) {
                        return JSON.parse(item.remindPeople).some((people) => this.peopleMapping[people] === role)
                    }
                    return true
                });
            })
        },
        deleteEvent(id) {
            Dialog.confirm({
                message: '确认删除吗'
            }).then(() => {
                deleteMemoRandum({ id }).then(() => {
                    this.getList();
                    this.$store.dispatch('updateShowWarning');
                    this.showModifyMemoRandum = false
                })
            });

        },
        onConfirmDate(date) {
            this.showCalendar = false
            this.finishDate = `${date.getMonth() + 1}/${date.getDate()}`;
        },
        beforeClose(action, done) {
            if (action === 'confirm') {
                const confirmInterval = setInterval(() => {
                    if (this.saveSuccessful) {
                        done()
                        clearInterval(confirmInterval)
                    }
                }, 100);
            } else {
                done()
            }
        },
        modifyMemorandum(item) {
            const { id, name, remark, remindPeople } = item
            this.id = id
            this.name = name
            this.remark = remark
            this.showModifyMemoRandum = true
            this.remindPeople = JSON.parse(remindPeople)
        },
        modifyMemorandumConfirm(btn) {
            let data = {
                name: this.name,
                finishDate: this.finishDate,
                remark: this.remark,
                remindPeople: this.remindPeople
            }
            if (this.id) {
                data.id = this.id
                data.type = btn ? btn?.type : this.activeType
            } else {
                data.type = 0
            }
            this.saveSuccessful = false
            updateMemoRandum(data).then(() => {
                this.getList();
                this.$store.dispatch('updateShowWarning');
                if (btn) {
                    this.showModifyMemoRandum = false
                }
                this.saveSuccessful = true
            })
        },
        closeDialog() {
            this.clearData()
        },
        clearData() {
            this.date = null
            this.name = null
            this.remark = null
            this.id = null
            this.remindPeople = ["0", "1", "2"]
        },
        generateRandomBalloon() {
            const r = this.rand(0, 220);
            const g = this.rand(0, 220);
            const b = this.rand(0, 220);
            return `rgb(${r},${g},${b})`;
        },
        rand(min, max) {
            return Math.round(Math.random() * (max - min) + min)
        },
        getLengthWidth(length) {
            if (length > 6) {
                return 'max-eigth'
            }
            if (length > 4) {
                return 'max-sixth'
            }
            if (length > 2) {
                return 'max-fourth'
            }
            return 'max-second'
        },
        getPosition(index) {
            if (index === 0) {
                return 'left-event'
            }
            return 'right-event'
        },
        getDisplayName(name) {
            if (name.length < 6) {
                return name
            }
            return `${name.substring(0, 6)}...`
        }
    },
    mounted() {
        this.getList();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
    /* Q版：柔和底色 + 贴纸卡片 */
    --q-bg0: #fff7fb;
    --q-bg1: #f2fbff;
    --q-card: rgba(255, 255, 255, 0.92);
    --q-line: rgba(15, 23, 42, 0.08);
    --q-shadow: 0 10px 24px rgba(17, 24, 39, 0.08);
    --q-shadow-sm: 0 6px 14px rgba(17, 24, 39, 0.08);
    --q-radius: 18px;
    --q-primary: #34c3ff;
    --q-primary-2: #6ee7ff;

    padding: 14px 14px 18px;
    display: flex;
    flex-direction: column;
    height: 100%;
    box-sizing: border-box;
    position: relative;
    font-family: "Comic Sans MS", "Microsoft YaHei UI", "PingFang SC", "Hiragino Sans GB", system-ui, -apple-system,
        BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
    background: radial-gradient(120% 90% at 20% 0%, var(--q-bg0) 0%, transparent 60%),
        radial-gradient(120% 90% at 90% 30%, var(--q-bg1) 0%, transparent 55%),
        #ffffff;
}

.content::before,
.content::after {
    content: "";
    position: fixed;
    z-index: -1;
    pointer-events: none;
    opacity: 0.9;
}
.content::before {
    width: 240px;
    height: 240px;
    left: -90px;
    top: 140px;
    background: radial-gradient(circle at 30% 30%, rgba(255, 184, 220, 0.55), transparent 60%),
        radial-gradient(circle at 70% 70%, rgba(110, 231, 255, 0.45), transparent 62%);
    border-radius: 999px;
}
.content::after {
    width: 280px;
    height: 280px;
    right: -140px;
    bottom: 90px;
    background: radial-gradient(circle at 40% 30%, rgba(196, 255, 214, 0.5), transparent 60%),
        radial-gradient(circle at 70% 70%, rgba(255, 224, 170, 0.45), transparent 62%);
    border-radius: 999px;
}
/* 不要对 `.content > *` 统一加 position/z-index，会破坏 Vant Dialog/Popup 的 fixed 布局 */

.content /deep/ .van-tabs__wrap {
    border: 1px solid var(--q-line);
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.86);
    box-shadow: var(--q-shadow-sm);
    overflow: hidden;
}
.content /deep/ .van-tabs__line {
    background: linear-gradient(180deg, var(--q-primary) 0%, var(--q-primary-2) 100%);
}
.content /deep/ .van-dialog {
    border-radius: 18px;
    overflow: hidden;
}

.van-cell__title {
    color: #646566;
}

.font-flower {
    margin: 0;
    font-size: 20px;
    text-align: center;
    color: transparent;
    background: linear-gradient(to right, #fff, #BF391B, #0D0D0D);
    -webkit-text-fill-color: transparent;
    background-clip: text;
    -webkit-background-clip: text;
    position: relative;
    letter-spacing: 0.4rem;
    font-style: italic;
    margin-bottom: 12px;
    letter-spacing: 0.18rem;
}

.font-flower::before,
.font-flower::after {
    content: attr(data-text);
    position: absolute;
    top: 0;
    left: 0;
    color: transparent;
    -webkit-text-stroke: 12px #000;
    z-index: -1;
}

.font-flower::after {
    -webkit-text-stroke: 17px #fff;
    z-index: -2;
}

.balloon-list {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    overflow-y: auto;
    margin-top: 12px;
    padding: 10px 10px 60px;
    border: 1px solid var(--q-line);
    border-radius: var(--q-radius);
    background: rgba(255, 255, 255, 0.86);
    box-shadow: var(--q-shadow-sm);
}

.balloon-list div {
    padding: 4px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #ffffff;
    box-shadow: 0 10px 18px rgba(17, 24, 39, 0.16);
    border: 2px solid rgba(255, 255, 255, 0.7);
    user-select: none;
    transition: transform 120ms ease, filter 120ms ease;
}

.balloon-list div:active {
    transform: translateY(1px) scale(0.985);
    filter: saturate(1.05);
}

.balloon-list .max-second {
    width: 40px;
    height: 40px;
    border-radius: 40px;
}

.balloon-list .max-fourth {
    border-radius: 40px;
    width: 44px;
    height: 44px;
}

.balloon-list .max-sixth {
    width: 56px;
    height: 56px;
    border-radius: 56px;
}

.balloon-list .max-eigth {
    width: 70px;
    height: 70px;
    border-radius: 70px;
}

.delete-event {
    position: absolute;
    top: 28px;
    right: 12px;
    font-size: 12px;
    color: red;
}

.left-event,
.right-event {
    width: 60px;
    position: absolute;
    top: 28px;
    right: 12px;
    font-size: 12px;
    color: red;
    border: 1px dotted;
    padding: 0 2px;
    text-align: center;
}

.right-event {
    left: 12px;
}

.add-menu /deep/ .van-radio--horizontal {
    font-size: 12px;
    margin-bottom: 4px;
}
</style>
